module.exports = __webpack_public_path__ + "img/security.b23aff1e.svg";